import React, { lazy, Suspense } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { handleKeyDown } from "views/utilities/enterFunctionForPOS";
import { Container } from "@mui/material";

const SalesHeader = lazy(() => import("./components/SalesHeader"));
const TableSection = lazy(() => import("./components/TableSection"));
const Footer = lazy(() => import("./components/Footer"));

const SkeletonLoader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5),
  height: "100px", // Adjust the height as needed
}));

const CardWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "#EFEBE9",
  // color: theme.palette.primary[800],
  color: " #ffc77d",
  minHeight: "calc(100vh - 50px)",
  maxHeight: "100%",
  overflow: "hidden",
  position: "relative",
  "&:before": {
    content: '""',
    zIndex: 0,
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${"#6D4C41"} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: "50%",
    top: -30,
    right: -100,
  },
  "&:after": {
    content: '""',
    position: "absolute",
    zIndex: -1,
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${"#8D6E63"} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
    borderRadius: "50%",
    top: -140,
    right: -60,
  },
}));

function SalesPosB2C() {
  return (
    <CardWrapper onDragStart={(e) => e.preventDefault()} onKeyDown={handleKeyDown}>
      <Container
        maxWidth="xl"
        sx={{
          py: 1.5,
          px: 0,
        }}
      >
        <Box sx={{ py: 0 }}>
          <Suspense fallback={<SkeletonLoader />}>
            <SalesHeader />
          </Suspense>
          <Box sx={{ py: 0.5 }}>
            <Suspense fallback={<SkeletonLoader />}>
              <TableSection />
            </Suspense>
          </Box>
          <Box sx={{ py: 0.5 }}>
            <Suspense fallback={<SkeletonLoader />}>
              <Footer />
            </Suspense>
          </Box>
        </Box>
      </Container>
    </CardWrapper>
  );
}

export default SalesPosB2C;
